const translations = {
  "en": {
    "A first read on your portfolio": "A first read on your portfolio",
    "Brokerage linked. I can see your holdings now.": "Brokerage linked. I can see your holdings now.",
    "I keep watching from here": "I keep watching from here",
    "I’ll go through what you’re holding and tell you what stands out.": "I’ll go through what you’re holding and tell you what stands out.",
    "I’ll show you which of your holdings are on this list, and how much is riding on them.": "I’ll show you which of your holdings are on this list, and how much is riding on them.",
    "If anything you own moves in a way that matters — on this list or not — I’ll say so. No noise.": "If anything you own moves in a way that matters — on this list or not — I’ll say so. No noise.",
    "Read-only — I can look, never move anything. Here’s what happens next.": "Read-only — I can look, never move anything. Here’s what happens next.",
    "Talk it through with Ed": "Talk it through with Ed",
    "What you own, against this ranking": "What you own, against this ranking"
  },
  "zh-tw": {
    "A first read on your portfolio": "初步分析你的投資組合",
    "Brokerage linked. I can see your holdings now.": "券商已連結，我可以查看你的持倉了。",
    "I keep watching from here": "接下來，我會持續關注",
    "I’ll go through what you’re holding and tell you what stands out.": "我會檢視你的持倉，告訴你值得注意的地方。",
    "I’ll show you which of your holdings are on this list, and how much is riding on them.": "我會告訴你哪些持倉在榜單中，以及你投入了多少資金。",
    "If anything you own moves in a way that matters — on this list or not — I’ll say so. No noise.": "無論是否在榜單中，只要你的持倉有重要變化，我就會告訴你，不用被雜訊打擾。",
    "Read-only — I can look, never move anything. Here’s what happens next.": "僅供讀取，我只能查看，無法操作你的資產。接下來我會：",
    "Talk it through with Ed": "和 Ed 聊聊",
    "What you own, against this ranking": "對照你的持倉與這份榜單"
  }
};

export default translations;
